import type { CategoryDto } from '#Products/models/Pim/CategoryDto'
import {
  resolveCategoryDestination,
  type CategoryDestination,
} from '#Products/support/categoryDestination'

/**
 * Wraps pure R1–R3 resolver + `ProductsRoutingService.getCatalogDestination()`.
 * v1: hub and PLP share `/catalog/:slug`; `destination` drives page type / chrome.
 */
export function useCategoryDestination() {
  const { routing } = useProducts()

  function resolve(
    category: Pick<CategoryDto, 'id' | 'name' | 'slug' | 'childrenIds'>,
  ): { destination: CategoryDestination, route: string } {
    const { type, route } = routing.getCatalogDestination(category)

    return { destination: type, route: route.route }
  }

  return {
    resolve,
    resolveCategoryDestination,
  }
}
